import {AssetsWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/assetsWorkspaceCapability/domain/AssetsWorkspaceCapabilityUdoTemplateKey";

import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type AssetsWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.assets> & {
    fixedUdoTemplates: {
        [AssetsWorkspaceCapabilityUdoTemplateKey.asset]: {
            udoAdditionalColumnIds: {
                mimeType: Uuid;
                name: Uuid;
                size: Uuid;
                status: Uuid;
            };
        };
    };
};

export const assetsWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [AssetsWorkspaceCapabilityUdoTemplateKey.asset]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({status: uuidZodValidator, mimeType: uuidZodValidator, name: uuidZodValidator, size: uuidZodValidator}),
            udoTemplateId: uuidZodValidator,
        }),
    }),
}) satisfies zod.ZodType<AssetsWorkspaceCapabilityUdoBindings>;
